import React from 'react';
import { BookOpenCheckIcon, GemIcon, ScrollTextIcon, ShieldCheckIcon } from 'lucide-react';
import { Section } from './Shared';
type Tome = {
  number: string;
  title: string;
  icon: React.ElementType;
  features: string[];
};
type Bonus = {
  number: string;
  title: string;
  description: string;
  value: string;
  image: string;
  landscape?: boolean;
};
const tomes: Tome[] = [{
  number: 'I',
  title: 'Manual Maestro de Gemoterapia Aplicada',
  icon: BookOpenCheckIcon,
  features: ['Introducción a la vibración mineral y al uso consciente de los cristales', 'Anatomía energética: chakras y correspondencias básicas', 'Cómo elegir cristales según la intención de trabajo', 'Limpieza, carga y programación con intención', 'Preparación personal y del espacio antes de una práctica', 'Criterios para crear una experiencia ordenada y respetuosa', 'Principios de uso responsable y consideraciones éticas', 'Fundamentos para dejar de depender de información dispersa']
}, {
  number: 'II',
  title: 'Libro de los Protocolos de Sesión',
  icon: ScrollTextIcon,
  features: ['Estructura clara para preparar, desarrollar y cerrar una sesión', 'Protocolo de Alineación', 'Protocolo de Calma y regulación emocional', 'Protocolo de Vitalidad y enfoque', 'Protocolo de Protección energética', 'Ubicación sugerida de cristales y tiempos orientativos', 'Intenciones y frases de acompañamiento para cada etapa', 'Guía para ganar orden y seguridad al facilitar una sesión']
}, {
  number: 'III',
  title: 'El Escudo del Terapeuta',
  icon: ShieldCheckIcon,
  features: ['Preparación y blindaje energético antes de acompañar a otras personas', 'Prácticas de limpieza personal después de una sesión', 'Recursos para cerrar la jornada con mayor presencia', 'Uso consciente de piedras negras y cristales de alta frecuencia', 'Cómo crear límites saludables entre tu energía personal y tu práctica', 'Señales para revisar tu descanso, tu espacio y tu ritmo de trabajo', 'Rutina breve entre sesiones', 'Ritual de cierre para finalizar el día de trabajo']
}, {
  number: 'IV',
  title: 'Diccionario de Cristales y Chakras',
  icon: GemIcon,
  features: ['Más de 50 cristales esenciales organizados para consulta rápida', 'Afinidad de cada piedra con los centros energéticos', 'Propiedades físicas, simbólicas y emocionales de cada cristal', 'Guía práctica de chakras y correspondencias', 'Recomendaciones de uso responsable', 'Combinaciones que conviene revisar antes de utilizar', 'Fichas de consulta para tener a mano durante tu práctica', 'Un mapa claro para elegir con más criterio']
}];
const bonuses: Bonus[] = [{
  number: '01',
  title: 'Guía Visual de Identificación',
  description: 'Un catálogo visual para reconocer cristales, observar sus características y diferenciar piezas auténticas de imitaciones o piedras teñidas.',
  value: 'US$19',
  image: 'https://cdn.magicpatterns.com/uploads/pnLX6bfzZqVs8rshE512v6/Screenshot_20260925-160805~2.jpg'
}, {
  number: '02',
  title: 'Fichas Profesionales de Seguimiento',
  description: 'Plantillas descargables para registrar los cristales utilizados, las intenciones trabajadas y las observaciones de cada encuentro.',
  value: 'US$17',
  image: 'https://cdn.magicpatterns.com/uploads/nopfYqhnEX92Ln6ivSi35H/Screenshot_20260925-160844~2.jpg'
}, {
  number: '03',
  title: 'Manual de Armonización de Espacios',
  description: 'Una guía para preparar y armonizar habitaciones, oficinas y espacios de práctica con cristales y rejillas básicas.',
  value: 'US$15',
  image: 'https://cdn.magicpatterns.com/uploads/c7sFPqamC3rKPjxvgdSZ5e/Screenshot_20260925-160914~2.jpg'
}, {
  number: '04',
  title: 'Masterclass PDF: “Tu Primera Sesión Exitosa”',
  description: 'Guía práctica y ética para preparar el ambiente, realizar una entrevista inicial, explicar tu propuesta y comenzar con una estructura clara.',
  value: 'US$27',
  image: 'https://cdn.magicpatterns.com/uploads/gAmd9mVQpc636tCV4QcNt8/Screenshot_20260925-160943~2.jpg'
}, {
  number: '05',
  title: 'Certificado de Excelencia en Gemoterapia',
  description: 'Certificado estético de Lumen Akasha™ con espacios en blanco para que cada alumna o alumno complete su nombre y fecha.',
  value: 'US$12',
  image: 'https://cdn.magicpatterns.com/uploads/wSdhThkAqgxtXCNrmCiAHY/Screenshot_20260925-161033~2.jpg',
  landscape: true
}];
export function PackContents() {
  return <Section id="contenido" data-id="element-192" data-mp="2fj62648wj1r5">
      <div className="mb-9 text-center" data-id="element-193" data-mp="336dy3vkfwygi">
        <p className="mb-2 text-sm font-bold uppercase tracking-[.18em] text-brand-goldDark" data-id="element-194" data-mp="337fhcnbm0r9b">🎁 Colección profesional</p>
        <h2 className="font-display text-3xl font-bold text-brand-purpleDark md:text-5xl" data-id="element-195" data-mp="387uvvi7mo4sv">
          4 Tomos Principales + 5 Bonus Estratégicos
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-base text-brand-muted md:text-lg" data-id="element-196" data-mp="2yf5oozj41d3c">
          Todo el sistema en un solo lugar. Tomos de consulta, protocolos, fichas y recursos para acompañar tu práctica
          con cristales de forma más organizada.
        </p>
      </div>

      <div className="mx-auto mb-12 max-w-6xl" data-id="element-197" data-mp="1fgzopryruh4t">
        <div className="mb-5 text-center" data-id="element-198" data-mp="1ffof3binaf5s">
          <p className="font-serif text-xl font-bold text-brand-purpleDark md:text-2xl" data-id="element-199" data-mp="1aiy2wz9yo3pn">
            Mira una muestra del material por dentro
          </p>
          <p className="mt-1 text-sm text-brand-muted" data-id="element-200" data-mp="1p9f3kgeruplh">
            Protocolos, fichas, guías y recursos listos para consultar desde tu tablet o imprimir.
          </p>
        </div>
        <div className="mx-auto max-w-[240px] overflow-hidden rounded-2xl border-2 border-brand-gold/40 bg-brand-purpleDark shadow-xl" data-id="element-201" data-mp="wj6t7aqh99hg">
          <video src="https://cdn.magicpatterns.com/uploads/42qjMb1cDw3UFHW4F4diZ2/LATAM_GEMO_Optimizado_Web.mp4" autoPlay loop muted playsInline className="h-full w-full object-cover" data-id="element-202" data-mp="15jd3knqvptce" />
        </div>
      </div>

      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-203" data-mp="2gy8i89pizusy">
        {tomes.map(tome => {
        const Icon = tome.icon;
        return <article key={tome.number} className="glass-panel rounded-2xl p-5" data-id="element-204" data-mp="2cwn4yn92xei8">
              <div className="mb-4 flex items-start gap-3" data-id="element-205" data-mp="19lhir1qpehdx">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-brand-purple text-brand-goldLight shadow-sm ring-1 ring-brand-gold/40" data-id="element-206" data-mp="1ekknsm6oonlw">
                  <Icon className="h-7 w-7" data-id="element-207" data-mp="1jicgvjj2efro" />
                </div>
                <div data-id="element-208" data-mp="1nl8roo2d57l2">
                  <p className="text-[10px] font-bold tracking-[.16em] text-brand-goldDark" data-id="element-209" data-mp="1njo63ny10yzc">TOMO {tome.number}</p>
                  <h3 className="font-serif text-base font-bold leading-tight text-brand-purpleDark" data-id="element-210" data-mp="vum6dfgzxi5l">{tome.title}</h3>
                </div>
              </div>
              <ul className="space-y-2 text-xs leading-snug text-brand-text" data-id="element-211" data-mp="zumvpv5mvdrf">
                {tome.features.map(feature => <li key={feature} className="flex gap-2" data-id="element-212" data-mp="14o7kqxp90xeh">
                    <span className="font-bold text-brand-goldDark" data-id="element-213" data-mp="85tim6aj2gm2">✓</span>
                    <span data-id="element-214" data-mp="c6del6jd7e6m">{feature}</span>
                  </li>)}
              </ul>
            </article>;
      })}
      </div>

      <div className="mb-6 mt-12 text-center" data-id="element-215" data-mp="4nci356zeksr">
        <h3 className="font-serif text-xl font-bold text-brand-purpleDark md:text-2xl" data-id="element-216" data-mp="4l02gyop4miv">
          🎁 5 BONUS ESTRATÉGICOS — <span className="text-brand-goldDark" data-id="element-217" data-mp="3vrkm3xcf8s5v">INCLUIDOS HOY</span>
        </h3>
      </div>

      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5" data-id="element-218" data-mp="3rtn013dy6m6p">
        {bonuses.map(bonus => <article key={bonus.number} className="flex flex-col overflow-hidden rounded-xl border border-brand-purple/20 bg-white shadow-sm" data-id="element-219" data-mp="3htckvd8cr4ow">
            <div className={`relative aspect-[3/4] overflow-hidden ${bonus.landscape ? 'flex items-center bg-brand-beige px-1.5' : 'bg-brand-purpleDark'}`} data-id="element-220" data-mp="3d24bgh70vjbq">
              <img src={bonus.image} alt={`Portada del Bonus ${bonus.number}: ${bonus.title}`} loading="lazy" className={bonus.landscape ? 'h-auto w-full rounded-sm object-contain shadow-md' : 'h-full w-full object-cover object-top'} data-id="element-221" data-mp="342hjsn43hrvv" />
              <span className="absolute right-0 top-0 rounded-bl-lg bg-brand-goldBright px-2 py-1 text-[9px] font-bold text-brand-purpleDark" data-id="element-222" data-mp="2u537mzp7fp9d">
                GRATIS
              </span>
            </div>
            <div className="flex flex-1 flex-col px-2.5 pb-3 pt-2 text-center" data-id="element-223" data-mp="qt5a8pcqt3p0">
              <p className="text-[10px] font-bold tracking-wide text-brand-goldDark" data-id="element-224" data-mp="cvgmn9rajig9">BONUS {bonus.number} — GRATIS</p>
              <p className="mt-1 text-[11px] font-bold leading-tight text-brand-purpleDark md:text-xs" data-id="element-225" data-mp="hsfetmre9fbt">{bonus.title}</p>
              <p className="mt-1.5 text-[10px] leading-snug text-brand-muted md:text-[11px]" data-id="element-226" data-mp="33jbg30a8qhj">{bonus.description}</p>
              <span className="mt-auto block pt-2 text-[10px] font-bold text-brand-purple md:text-[11px]" data-id="element-227" data-mp="7xf6awl91x8h">
                Valor real <span className="text-brand-muted line-through" data-id="element-228" data-mp="3uavt0j52v5xz">{bonus.value}</span> → GRATIS
              </span>
            </div>
          </article>)}
      </div>

      <div className="mt-7 text-center" data-id="element-229" data-mp="3gc5ucz2m0y7i">
        <p className="inline-block rounded-full border border-brand-gold/60 bg-white px-5 py-3 text-sm font-medium text-brand-text" data-id="element-230" data-mp="3la7bhegh6ngc">
          Todo el valor de los bonus está <span className="font-bold text-brand-purple" data-id="element-231" data-mp="31qrquavkaoho">incluido con tu Mega Pack</span>.
        </p>
      </div>
    </Section>;
}